import axios from 'axios';
import storage from '@/util/storage';


export const initialState = {
	init: false,
	accessToken: storage.get('auth.accessToken'),
	currentUser: storage.get('auth.currentUser'),
};

export const mutations = {
  RESET(state) {
    Object.entries(state).forEach(([key]) => {
      state[key] = null;
      storage.set(`auth.${key}`, null);
    });
  },
  SET_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken;
    storage.set('auth.accessToken', accessToken);
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = user;
    storage.set('auth.currentUser', state.currentUser);
  },
  UPDATE_CURRENT_USER(state, user) {
    Object.assign(state.currentUser, user);
    storage.set('auth.currentUser', state.currentUser);
  },
  UPDATE_CURRENT_USER_BILLING_ADDRESS(state, billingAddress) {
    Object.assign(state.currentUser.billingAddress, billingAddress);
    storage.set('auth.currentUser', state.currentUser);
  },
  
};

export const getters = {
  hasStripe: state => state.currentUser.hasStripe,
  isLoggedIn: state => !!state.accessToken,
}

export const actions = {

  async init({ commit, dispatch }) {
    await dispatch('getUser');
    commit('INIT');
  },

  async register(context, { email, password }) {
    await axios.post('/user', { email, password });

  },

  async login({ commit }, { email, password }) {
    const { data } = await axios.post('/auth/login', { email, password });
    const { accessToken, user } = data;
    commit('SET_ACCESS_TOKEN', accessToken);
    commit('SET_CURRENT_USER', user);
  },

  async requestPassword(context, { email }) {
    await axios.post('/user/password/request', { email });
  },

  async refreshToken({ commit }) {
    const res = await axios.get('/auth/refreshToken', {
      validateStatus: status => status < 500,
    });
    const accessToken = res.status < 300 ? res.data.accessToken : null;
    commit('SET_ACCESS_TOKEN', accessToken);
  },

  async resetPassword(context, { resetKey, password }) {
    await axios.post('/user/password/reset', { resetKey, password });
  },

  logout({ commit }) {
    commit('RESET');
  },

  async updateUser({ commit, state }, user) {
    user = Object.assign({}, user || state.currentUser);
    delete user.email;
    const { data } = await axios.put('/user', user);
    commit('SET_CURRENT_USER', data);
  },

  async getUser({ state, commit }) { 
    const { data } = await axios.get(`/user/${state.currentUser.ID}`);
    commit('SET_CURRENT_USER', data);
  },


};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
